module.exports = __webpack_public_path__ + "static/ample-logo-de9bed675f09627e871690ba2beac239.png";